import { type TFunction } from 'i18next';

export const PLAYDECK_COMMUNITY_CHANNEL_EN_URL = 'https://t.me/playcoin';
export const PLAYDECK_COMMUNITY_CHANNEL_RU_URL = 'https://t.me/PlayDeckCommunity';

export const PLAYDECK_SUPPORT_TG_LINK = 'https://t.me/playdecksupportbot';

export const DEV_TG_BOT_LINK = 'https://t.me/replay_deck_bot';
export const PROD_TG_BOT_LINK = 'https://t.me/playdeckbot';
export const BASE_URL_MARKET = '/market';

export const DEV_TG_WRAPPER_LINK = 'https://t.me/replay_deck_bot/wrapper';
export const PROD_TG_WRAPPER_LINK = 'https://t.me/playdeckbot/game';

export const IS_DEV_API = import.meta.env.VITE_APP_API_URL
  ? import.meta.env.VITE_APP_API_URL.includes('api-test')
  : false;

export const BOT_LINK = IS_DEV_API ? DEV_TG_BOT_LINK : PROD_TG_BOT_LINK;
export const GAME_WRAPPER_APP_LINK = IS_DEV_API
  ? DEV_TG_WRAPPER_LINK
  : PROD_TG_WRAPPER_LINK;

export const CIS_COUNTRY_CODES = [
  'RU', // Russia
  'BY', // Belarus
  'KZ', // Kazakhstan
  'KG', // Kyrgyzstan
  'TJ', // Tajikistan
  'UZ', // Uzbekistan
];

export const MENA_COUNTRY_CODES = [
  'DZ', // Algeria
  'BH', // Bahrain
  'EG', // Egypt
  'IQ', // Iraq
  'JO', // Jordan
  'IR', // Iran
  'YE', // Yemen
  'QA', // Qatar
  'KW', // Kuwait
  'LB', // Lebanon
  'LY', // Libya
  'MA', // Morocco
  'AE', // United Arab Emirates (UAE)
  'OM', // Oman
  'PS', // Palestine
  'SA', // Saudi Arabia
  'SY', // Syria
  'SD', // Sudan
  'TN', // Tunisia
];

export const PUSH_LOOTBOX_PARAM_KEY = 'pushLootbox';
export const SHOP_LOOTBOX_PARAM_KEY = 'shopLootbox';
export const NEW_LINE = '%0A';

export const makeShareReferralText = (t: TFunction) => {
  return {
    title: t('Let’s be friends in PlayDeck!'),
    message: [
      t('🎮 Play your favorite games and earn $NOT, $PlayCoin and much more💎'),
      t('New here? Grab 1,000 coins as a welcome gift'),
    ].join(NEW_LINE),
  };
};

export const TERMS_AND_CONDITIONS_LINK = 'https://telegram.org/tos/mini-apps';
export const PRIVACY_POLICY_LINK_PDF =
  'https://pd-static.playdeck.io/terms/Privacy-Policy.pdf';

// игра от партнера Sports & Winline
export const GAME_ID_WITH_AGE_RESTRICTION = 'tFyWoQbvKE';

export const MOST_POPULAR_SELECTION_KEY = 'fj4tf9ehbg';
export const OUR_FAVORITES_SELECTION_KEY = 'qhpy92h6le';

export const PERFORMANCE_CLASS_STORED_KEY = 'performamce_class';

export const DESKTOP_PLATFORMS = ['macos', 'tdesktop', 'unknown', 'web'];

export const INIT_URL_SESSION_KEY = 'init-url';

export const SHOULD_UPDATE_TASKS_PAGE_DATA = 'SHOULD_UPDATE_TASKS_PAGE_DATA';

export const SHOULD_UPDATE_PVP_LB = 'SHOULD_UPDATE_PVP_LB';
